<div class="ratings-container">

  <!-- App Store Column -->
  <div class="reviews-column">
    <div class="column-header">
      <!-- You can add an icon here if available -->
      <h2>App Store Reviewss</h2>
    </div>

    <div class="loading-state" *ngIf="loading">
      <span>Loading reviews...</span>
    </div>

    <div class="reviews-list" *ngIf="!loading">
      <div class="review-card" *ngFor="let review of appStoreReviews">
        <div class="review-header">
          <div class="stars">
            <span *ngFor="let star of [1,2,3,4,5]" class="star" [class.filled]="star <= review.rating">★</span>
          </div>
          <span class="review-date">{{ review.date | date:'MMM d, y' }}</span>
        </div>

        <h3 class="review-title" *ngIf="review.title">{{ review.title }}</h3>

        <p class="review-content">{{ review.content }}</p>

        <div class="review-footer">
          <span class="review-author">by {{ review.author }}</span>
        </div>
      </div>

      <div *ngIf="appStoreReviews.length === 0" class="no-reviews">
        No App Store reviews found.
      </div>
    </div>
  </div>

  <!-- Play Store Column -->
  <div class="reviews-column">
    <div class="column-header">
      <h2>Play Store Reviews</h2>
    </div>

    <div class="loading-state" *ngIf="loading">
      <span>Loading reviews...</span>
    </div>

    <div class="reviews-list" *ngIf="!loading">
      <div class="review-card" *ngFor="let review of playStoreReviews">
        <div class="review-header">
          <div class="stars">
            <span *ngFor="let star of [1,2,3,4,5]" class="star" [class.filled]="star <= review.rating">★</span>
          </div>
          <span class="review-date">{{ review.date | date:'MMM d, y' }}</span>
        </div>

        <!-- Play Store reviews usually don't have titles, but if we mapped one, show it -->
        <h3 class="review-title" *ngIf="review.title">{{ review.title }}</h3>

        <p class="review-content">{{ review.content }}</p>

        <div class="review-footer">
          <span class="review-author">by {{ review.author }}</span>
        </div>
      </div>

      <div *ngIf="playStoreReviews.length === 0" class="no-reviews">
        No Play Store reviews found.
      </div>
    </div>
  </div>

</div>
